import React from 'react';
import { IndexRedirect, Route } from '@americanexpress/one-app-router';
import { updateLocale } from '@americanexpress/one-app-ducks';
import * as moment from 'moment-timezone';
import LandingPage from '@/components/landing/LandingPage';
import SearchPage from '@/components/search/SearchPage';
import LoungeDetailsPage from '@/components/details/LoungeDetailsPage';
import AllAirportsPage from '@/components/allAirports/AllAirportsPage';
import NotFound from '@/components/NotFound';
import {
  // isNewUrl,
  // getBasePathFromLocation,
  // 👆 these 2 are for checking which URL structure to use when redirecting invalid-locales to the 404 page
  getSafeLocaleUtil,
  setAXPLocaleCookie,
} from '@/helpers/utils';

const onEnterSanitizePathnameFromRoute =
  ({ dispatch }) =>
  async (props, replace, onLoadComplete) => {
    // append trailing slash to all URLs
    // i.e. https://www.americanexpress.com/en-us/travel/lounges/the-platinum-card -> https://www.americanexpress.com/en-us/travel/lounges/the-platinum-card/
    const { pathname, search } = props.location;
    let currentURL = pathname;

    if (pathname.slice(-1) !== '/') {
      currentURL += `/${search}`;
      replace(currentURL);
    }

    // redirect uppercase locale to lowercase,
    // e.g. /en-US/travel/lounges/the-platinum-card -> /en-us/travel/lounges/the-platinum-card
    const localeAllLower = props.params.locale?.toLowerCase();
    if (localeAllLower !== props.params.locale) {
      replace(currentURL.replace(props.params.locale, localeAllLower));
    }

    const unsafeLocale =
      props.location.query?.locale || props.params.locale || 'en-US';
    const safeLocale = getSafeLocaleUtil(unsafeLocale);

    await dispatch(updateLocale(safeLocale));
    moment.locale(safeLocale.slice(0, 2));
    setAXPLocaleCookie(safeLocale); // Required for Analytics Tracking to reflect the correct locale.

    // else {
    //   // requested locale is one that LoungeFinder doesn't explicitly have content for
    //   // redirect to 404 content
    //   const basePath = getBasePathFromLocation(
    //     'en-US',
    //     props.location.pathname
    //   );
    //   const notFoundRoute = `${basePath}/not-found${isNewUrl(props.location.pathname) ? '' : '?locale=en-US'}`;
    //   const shouldRedirectToNotFoundRoute =
    //     !props.location.pathname.includes('not-found'); // prevent the not-found page from redirecting to itself in a loop.
    //   if (shouldRedirectToNotFoundRoute) {
    //     replace({
    //       state: {
    //         status: 404,
    //       },
    //       pathname: notFoundRoute,
    //     });
    //   }
    // }
    onLoadComplete();
  };

const childRoutes = (store) => [
  <Route
    key="localeHook"
    path="/"
    onEnter={onEnterSanitizePathnameFromRoute(store)}
  >
    {/* ---------------- Begin NEW Routes ---------------- */}
    <Route path=":locale/travel/lounges/:product" component={LandingPage} />
    <Route
      path=":locale/travel/lounges/:product/all-airports"
      component={AllAirportsPage}
    />
    <Route
      path=":locale/travel/lounges/:product/:airportCode"
      component={SearchPage}
    />
    <Route
      path=":locale/travel/lounges/:product/:airportCode/:loungeId"
      component={LoungeDetailsPage}
    />
    {/* <IndexRedirect to="en-us/travel/lounges/the-platinum-card" /> */}
    {/* ---------------- End NEW Routes ---------------- */}
    <Route path="lounge-access/:product" component={LandingPage} />
    <Route
      path="lounge-access/:product/all-airports"
      component={AllAirportsPage}
    />
    <Route path="lounge-access/:product/:airportCode" component={SearchPage} />
    <Route
      path="lounge-access/:product/:airportCode/:loungeId"
      component={LoungeDetailsPage}
    />
    <Route path="*" component={NotFound} />
    <IndexRedirect to="lounge-access/the-platinum-card" />
  </Route>,
];

export default childRoutes;
